import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';
// import * as toast from 'components/Toast/toast';
function transformRolesList(rolesList) {
  const result = [];
  rolesList.forEach((role) => {
    role.permissions.forEach((permission) => {
      let permissionObj = result.find(
        (p) => p.permissionsName === permission.displayName
      );

      if (!permissionObj) {
        permissionObj = { permissionsName: permission.displayName };
        result.push(permissionObj);
      }
      permissionObj[role.name] = {
        roleId: role.id,
        id: permission.id,
        resource: permission.resource,
        displayName: permission.displayName,
        read: permission.read,
        write: permission.write,
        writeonly: permission.writeonly,
        hasMenu: permission.hasMenu || false,
        showInMenu: permission.showInMenu || false
      };
    });
  });

  result.sort((a, b) => a.permissionsName.localeCompare(b.permissionsName));

  return result;
}
const initialState = {
  loading: false,
  rolesList: [],
  dataList: []
};
const rolesAndPermissions = createSlice({
  name: 'rolesAndPermissions',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getRolesList(state, action) {
      const sortedRoles = action.payload.map((role) => ({
        ...role,
        permissions: [...role.permissions].sort((a, b) =>
          a.displayName.localeCompare(b.displayName)
        )
      }));

      return {
        ...state,
        rolesList: sortedRoles,
        dataList: transformRolesList(action.payload)
      };
    },
    editRoles(state, action) {
      const rolesList = state.rolesList.map((item) =>
        item.id === action.payload.id
          ? {
              ...action.payload,
              permissions: [...action.payload.permissions].sort((a, b) =>
                a.displayName.localeCompare(b.displayName)
              )
            }
          : item
      );

      return {
        ...state,
        rolesList,
        dataList: transformRolesList(rolesList)
      };
    }
  }
});

export default rolesAndPermissions.reducer;

export const RolesAndPermissionsActions = rolesAndPermissions.actions;

const mergePermissions = (response) => {
  const roles = response.data;
  const allPermissions = {};

  // Собираем уникальные пермишоны
  roles.forEach((role) => {
    role.permissions.forEach((permission) => {
      const key = `${permission.id}-${permission.displayName}`; // Уникальный ключ на основе id и имени

      if (!allPermissions[key]) {
        allPermissions[key] = {
          id: permission.id,
          resource: permission.resource,
          displayName: permission.displayName,
          writeonly: false, // По умолчанию false
          hasMenu: permission.hasMenu || false,
          showInMenu: permission.showInMenu || false
        };
      }

      // Если хотя бы у одного пермишона с таким же именем есть writeonly: true, проставляем всем с этим именем
      if (permission.writeonly) {
        allPermissions[key].writeonly = true;
      }
    });
  });

  const uniquePermissions = Object.values(allPermissions);

  // Обновляем роли
  const updatedRoles = roles.map((role) => {
    const updatedPermissions = uniquePermissions.map((permission) => {
      const existingPermission = role.permissions.find(
        (p) => p.displayName === permission.displayName // Теперь сравниваем по названию
      );

      return {
        ...permission,
        read: existingPermission ? existingPermission.read : false,
        write: existingPermission ? existingPermission.write : false,
        writeonly: permission.writeonly, // Теперь у всех с этим `displayName` writeonly будет одинаковым
        hasMenu: permission.hasMenu, // добавить
        showInMenu: existingPermission ? existingPermission.showInMenu : false
      };
    });

    return {
      ...role,
      permissions: updatedPermissions
    };
  });

  return {
    ...response,
    data: updatedRoles
  };
};
export const getRolesAndPermissions = () => async (dispatch) => {
  dispatch(RolesAndPermissionsActions.setLoading(true));
  try {
    const res = await api.get('api/Role');
    if (res.status === 200 && res?.data) {
      const mergedData = mergePermissions(res?.data);
      dispatch(RolesAndPermissionsActions.getRolesList(mergedData?.data));
    }
  } catch (errors) {
    formErrorsHandle(errors?.response?.data, []);
  } finally {
    dispatch(RolesAndPermissionsActions.setLoading(false));
  }
};
export const revertRoleAction = (id, setRevertDialog) => async (dispatch) => {
  try {
    const res = await api.patch(`api/Role/${id}/reset`);
    if (res.status === 200 && res?.data) {
      dispatch(getRolesAndPermissions());
      setRevertDialog('');
      toast.success('Reverted successfully!!!');
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
  }
};
export const removeRoleAction = (id, setRemoveDialog) => async (dispatch) => {
  try {
    const res = await api.delete(`api/Role/${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(getRolesAndPermissions());
      setRemoveDialog('');
      toast.success('Removed successfully!!!');
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
  }
};
export const editRoleAction = (role, setEditRoleAction) => async (dispatch) => {
  try {
    await api.put(`api/Role/${role.id}`, role);
    setEditRoleAction('');
    dispatch(getRolesAndPermissions());
    toast.success('Edited successfully!!!');
  } catch (errors) {
    if (errors.response?.data) {
      formErrorsHandle(errors.response?.data, []);
    }
  }
};
export const createRoleAction = (role, navigate) => async (dispatch) => {
  try {
    const res = await api.post(`api/Role`, role);
    if (res.status === 200 && res?.data) {
      await dispatch(getRolesAndPermissions());
      toast.success('Create successfully!!!');
      navigate('/admin/roles-and-permissions');
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    // return Promise.reject(errors);
  }
};
